import auth from "./middleware/auth";

export default [
  {
    path: "/",
    name: "Companies",
    component: require("@/views/Companies/List").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":id",
    name: "Company",
    component: require("@/views/Companies/Item").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":companyId/documents",
    name: "CompanyDocuments",
    component: require("@/views/CompanyDocuments/List").default,
    meta: {
      middleware: auth,
    },
  },
  {
    path: ":companyId/documents/:id",
    name: "CompanyDocument",
    component: require("@/views/CompanyDocuments/Item").default,
    meta: {
      middleware: auth,
    },
  },
];
